import React from 'react';
import { Link } from 'react-router-dom';
import './PolicyPages.css';

const DisclaimerPage = () => {
  return (
    <div className="policy-page">
      <div className="policy-container">
        <Link to="/" className="back-link">← Back to SlimBuddy</Link>
        
        <h1>Important Disclaimer</h1>
        
        <div className="effective-date">
          <strong>Last Updated:</strong> September 28, 2025
        </div>

        <p>When using SlimBuddy you acknowledge that:</p>

        <ul>
          <li>SlimBuddy provides general health and fitness information for educational purposes only.</li>
          <li>This app is not a substitute for professional medical advice, diagnosis, or treatment.</li>
          <li>Always consult with your physician before starting any new diet or exercise program.</li>
          <li>Individual results may vary and are not guaranteed.</li>
          <li>You are responsible for your own health and safety while using this app.</li>
        </ul>
      </div>
    </div>
  );
};

export default DisclaimerPage;